import AppLayout from 'components/layouts/AppLayout';
import React, { Fragment, lazy, useEffect } from 'react';
import P from 'router/paths';
import AlertMessage from '../components/Dialogs/AlertMessage';
import { WIZARD_STEP } from './wizardUtils';
import AdDetailDrawer from 'components/Drawers/AdDetailDrawer/AdDetailDrawer';
import Module from 'modules/Module';
import useAuth from 'store/redux/hooks/useAuth';
import AdsetCopyModal from 'components/Modals/AdsetCopyModal';
import CampaignCopyModal from 'components/Modals/CampaignCopyModal';
import SocketNotifications from 'components/notifications/SocketNotifications';
import Drawers from 'modules/Drawers';
import useWorkspaceBilling from 'store/redux/hooks/useWorkspaceBilling';
import AppsModule from 'modules/apps';
import ReportModule from 'modules/ReportModule';
import { initSocket } from 'store/socket/socket';
import { tokenKey } from '@ninja/consts';
import storage from '@ninja/storage';
import useSocket from 'utils/socket/useSocket';
import WebsiteModule from 'modules/website/WebsiteModule';
import { sendUserDataInCrisp } from '@lib/crisp';
import { Redirect, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const AudiencesModule = lazy(() => import('modules/AudiencesModule'));
const DashboardModule = lazy(() => import('modules/DashboardModule'));
const SalesModule = lazy(() => import('modules/sales/SalesModule'));
const SetupModule = lazy(() => import('modules/setup'));
const CRMModule = lazy(() => import('./CRMModule'));
const ReportingModule = lazy(() => import('./ReportingModule'));
const SettingsModule = lazy(() => import('./SettingsModule'));
const WebsiteBuilderModule = lazy(() => import('./WebsiteBuilderModule/WebsiteBuilderModule'));
const DomainModule = lazy(() => import('./DomainModule'));
const NotificationsModule = lazy(() => import('./NotificationsModule/NotificationsModule'));
const PostbacksModule = lazy(() => import('./PostbacksModule'));
const UrlModule = lazy(() => import('./UrlModule'));
const AccountsModule = lazy(() => import('./AccountsModule'));
const BillingModule = lazy(() => import('./BillingModule'));
const RetentionModule = lazy(() => import('./RetentionModule'));
const PnLReportModule = lazy(() => import('./PnLReportModule'));
const AcquisitionModule = lazy(() => import('./AcquisitionModule'));
const ProductsModule = lazy(() => import('./ProductsModule'));
const NinjaAiModule = lazy(() => import('./NinjaAiModule'));
// const AppsModule = lazy(() => import('./apps'));
const { Error404Page, PermissionErrorPage } = lazy(() => import('./ErrorsModule'));

const appModule = new Module({
  routes: [
    { path: P.APP, component: DashboardModule, exact: true, middleware: ['auth'] },
    {
      path: P.DASHBOARD.INDEX,
      component: DashboardModule,
      middleware: ['auth', `wizard:${WIZARD_STEP.accounts}`],
    },
    { path: P.NOTIFICATIONS.INDEX, component: NotificationsModule, middleware: ['auth'] },
    { path: P.BILLING.INDEX, component: BillingModule, middleware: ['auth'] },
    { path: P.SETUP.INDEX, component: SetupModule, middleware: [`wizard:${WIZARD_STEP.setup}`] },
    { path: P.PROFILE.INDEX, component: SettingsModule },
    {
      path: P.REPORTING.INDEX,
      component: ReportingModule,
      middleware: [`wizard:${WIZARD_STEP.accounts}`],
    },
    { path: P.AUDIENCES.INDEX, component: AudiencesModule, middleware: ['auth'] },
    { path: P.CRM.INDEX, component: CRMModule, middleware: [`wizard:${WIZARD_STEP.accounts}`] },
    { path: P.BUILDER.INDEX, component: WebsiteBuilderModule },
    { path: P.SALES.INDEX, component: SalesModule, middleware: ['auth', 'viewer:sale'] },
    {
      path: P.DOMAIN.INDEX,
      component: DomainModule,
      middleware: [`wizard:${WIZARD_STEP.accounts}`],
    },
    {
      path: P.WEBSITES.INDEX,
      component: WebsiteModule,
    },
    { path: P.POSTBACKS.INDEX, component: PostbacksModule, middleware: ['auth'] },
    { path: P.RETENTION.INDEX, component: RetentionModule, middleware: ['auth'] },
    { path: P.URL.INDEX, component: UrlModule, middleware: ['auth'] },
    {
      path: P.ACCOUNTS.INDEX,
      component: AccountsModule,
      middleware: [`wizard:${WIZARD_STEP.accounts}`],
    },
    {
      path: P.REPORT.INDEX,
      component: ReportModule,
    },
    {
      path: P.APPS.INDEX,
      component: AppsModule,
    },
    {
      path: P.PNL_REPORT.INDEX,
      component: PnLReportModule,
    },
    {
      path: P.ACQUISITION.INDEX,
      component: AcquisitionModule,
    },
    {
      path: P.PRODUCTS.INDEX,
      component: ProductsModule,
    },
    {
      path: P.NINJA_AI.INDEX,
      component: NinjaAiModule,
    },
    {
      path: '/no-permission',
      component: PermissionErrorPage,
    },
    {
      path: '*',
      component: Error404Page,
    },
  ],
});

const BootstrapAppModule = () => {
  const { user } = useAuth();
  const { hasPlan, is_active, isLoading: isPlanLoading } = useWorkspaceBilling();

  useEffect(() => {
    sendUserDataInCrisp(user);
  }, [user]);

  useEffect(() => {
    initSocket(storage.get(tokenKey), {});
  }, []);

  // @todo move to middleware
  if (!isPlanLoading && !hasPlan && window.location.pathname !== P.BILLING.CHOOSE_PLAN) {
    return <Redirect to={P.BILLING.CHOOSE_PLAN} />;
  }

  return (
    <Fragment>
      <SocketNotifications />
      <Drawers />
      <AppLayout>{appModule.render()}</AppLayout>
      {/** @todo remove */}
      <AlertMessage />
      {/** @todo refactor */}
      <AdDetailDrawer />
      {/** @todo refactor */}
      <AdsetCopyModal />
      {/** @todo refactor */}
      <CampaignCopyModal />
    </Fragment>
  );
};

export default BootstrapAppModule;
